import { useState } from "react";
import { formatIsoDate } from "utils/date";
import formatDate from "utils/formatDate";

const useBPChart = (bpData) => {
  const [lastSystolic, setLastSystolic] = useState(null);
  const [lastSystolicX, setLastSystolicX] = useState(null);
  const [lastSystolicY, setLastSystolicY] = useState(null);
  const [lastDiastolic, setLastDiastolic] = useState(null);
  const [lastDiastolicX, setLastDiastolicX] = useState(null);
  const [lastDiastolicY, setLastDiastolicY] = useState(null);

  const getDiastolicLines = (data) => {
    const { plottedData } = data.diastolic;

    const lineData = plottedData.map((p) => {
      const formattedDate = formatIsoDate(p.timestamp);

      return {
        value: formatDate(formattedDate),
        DiastolicLine: p.value,
      };
    });

    return lineData;
  };

  const getSystolicLines = (data) => {
    const { plottedData } = data.systolic;

    const lineData = plottedData.map((p) => {
      const formattedDate = formatIsoDate(p.timestamp);

      return {
        value: formatDate(formattedDate),
        SystolicLine: p.value,
      };
    });

    return lineData;
  };

  const getscatterDiastolic = (data) => {
    const { allData } = data.diastolic;

    const scatterData = allData.map((p) => {
      const formattedDate = formatIsoDate(p.timestamp);
      return {
        value: formatDate(formattedDate),
        Diastolic: p.value,
      };
    });

    return scatterData;
  };

  const getscatterSystolic = (data) => {
    const { allData } = data.systolic;

    const scatterData = allData.map((p) => {
      const formattedDate = formatIsoDate(p.timestamp);
      return {
        value: formatDate(formattedDate),
        Systolic: p.value,
      };
    });

    return scatterData;
  };

  const getScatterPoints = (data) => {
    const scatterDiastolic = getscatterDiastolic(data);
    const scatterSystolic = getscatterSystolic(data);

    const scatterData = scatterDiastolic.map((d, i) => {
      if (d.value !== scatterSystolic[i].value) return null;

      return {
        value: d.value,
        Diastolic: d.Diastolic,
        Systolic: scatterSystolic[i].Systolic,
      };
    });

    return scatterData;
  };

  const generateDataObject = (data) => {
    const diastolicLines = getDiastolicLines(data);
    const systolicLines = getSystolicLines(data);
    const scatterPoints = getScatterPoints(data);

    return [
      ...new Set([...scatterPoints, ...diastolicLines, ...systolicLines]),
    ];
  };

  const CustomizedDot = (props) => {
    const { cx, cy, dataKey } = props;
    const lastSystolicIndex = bpData.systolic.plottedData.length;
    const lastSystolicValue =
      bpData.systolic.plottedData[lastSystolicIndex - 1].value;

    const lastDiastolicIndex = bpData.diastolic.plottedData.length;
    const lastDiastolicValue =
      bpData.diastolic.plottedData[lastDiastolicIndex - 1].value;

    if (dataKey === "SystolicLine") {
      setLastSystolic(lastSystolicValue);
      setLastSystolicX(parseInt(cx + 20));
      setLastSystolicY(parseInt(cy + 10));
    }

    if (dataKey === "DiastolicLine") {
      setLastDiastolic(lastDiastolicValue);
      setLastDiastolicX(parseInt(cx + 20));
      setLastDiastolicY(cy + 120 + 80);
    }

    return null;
  };

  return {
    generateDataObject,
    CustomizedDot,

    lastDiastolic,
    lastSystolic,

    lastDiastolicX,
    lastDiastolicY,
    lastSystolicX,
    lastSystolicY,
  };
};

export default useBPChart;
